import ManageBulkMessage from '@/PageComponents/Message/ManageBulkMessage';
import Breadcrumbs from '@/components/breadcrumbs';
import { FC } from 'react';
import { useRouter } from 'next/router';
import * as Enums from '@/utils/enums';
import { createFileRoute } from '@tanstack/react-router'

const EditBulkMessage: FC = () => {
    const router = useRouter();
    const { id } = router.query; // TODO(tanstack-router): verify router.query → useParams/useSearch

    return (<>

        <div className="manage-container">

            <div className="title">
                <Breadcrumbs currPage={{ text: "Editing Bulk SMS", link: `/message/bulk/${id}` }} />
            </div>

            <ManageBulkMessage inModal={false} id={id as string} messageType={Enums.MessageType.SMS}/>

        </div>

        <style jsx>{`
            
        `}</style>
    </>);
};

export default EditBulkMessage;

export const Route = createFileRoute('/_authenticated/message/bulk/$id')({ component: EditBulkMessage })
